import { render, staticRenderFns } from "./lossSubsidy.vue?vue&type=template&id=950d3c02&scoped=true"
import script from "./lossSubsidy.vue?vue&type=script&lang=js"
export * from "./lossSubsidy.vue?vue&type=script&lang=js"
import style0 from "./lossSubsidy.vue?vue&type=style&index=0&id=950d3c02&prod&lang=css"
import style1 from "./lossSubsidy.vue?vue&type=style&index=1&id=950d3c02&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "950d3c02",
  null
  
)

export default component.exports